module.exports = __webpack_public_path__ + "static/media/bl.fbaf057d.svg";